import { z } from "zod";
import { RouteMap } from "./customerReporting";

export const cashRequirementsSchema = z.object({
  check_date: z.string(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  speed: z.string().optional(),
  debit_download_checks: z.boolean().optional(),
  exclude_taxes_from_company_debit: z.boolean().optional(),
  refunded: z.string(),
  total_company_debit: z.string(),
  garnishment: z.string(),
  direct_deposit: z.string(),
  download_check: z.string(),
  physical_check: z.string(),
  employee_taxes: z.string(),
  employer_taxes: z.string(),
  total_plus_refunds: z.string(),
  total_extra_cash: z.string(),
  total_cash_requirements: z.string(),
});

export type CashRequirementsShape = z.infer<typeof cashRequirementsSchema> & {
  kind: RouteMap.cash_requirements;
  extra_contributions: {
    [x: string]: string;
  };
};
